import React from 'react';
import Icon from '../../../components/AppIcon';
import { Card, CardContent } from '../../../components/ui/Card';
import Badge from '../../../components/ui/Badge';

const KPICard = ({ title, value, subtitle, trend, trendValue, icon, iconColor, status }) => {
  const getTrendColor = () => {
    if (trend === 'up') return 'text-success-600';
    if (trend === 'down') return 'text-danger-600';
    return 'text-neutral-600';
  };

  const getStatusVariant = () => {
    if (status === 'success') return 'success';
    if (status === 'warning') return 'warning';
    if (status === 'error') return 'danger';
    return 'default';
  };

  const getIconBgColor = () => {
    if (iconColor) return iconColor;
    if (trend === 'up') return 'bg-success-500';
    if (trend === 'down') return 'bg-danger-500';
    return 'bg-primary-500';
  };

  return (
    <Card hover shadow="md" className="border border-border">
      <CardContent className="p-4 md:p-6">
        <div className="flex items-start justify-between mb-3 md:mb-4">
          <div className="flex-1">
            <p className="text-body-sm text-muted-foreground font-medium mb-1 md:mb-2">
              {title}
            </p>
            <h3 className="text-h2 font-heading font-bold text-foreground">
              {value}
            </h3>
            {subtitle && (
              <p className="text-body-sm text-muted-foreground mt-1 md:mt-2">
                {subtitle}
              </p>
            )}
          </div>
          <div className={`w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 rounded-lg flex items-center justify-center ${getIconBgColor()}`}>
            <Icon name={icon} size={20} className="md:w-6 md:h-6 lg:w-7 lg:h-7" color="white" />
          </div>
        </div>
        {trend && trendValue && (
          <div className="flex items-center gap-2">
            <div className={`flex items-center gap-1 ${getTrendColor()}`}>
              <Icon 
                name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'} 
                size={16} 
              />
              <span className="text-body-sm font-medium">{trendValue}</span>
            </div>
            <span className="text-body-sm text-muted-foreground">vs last month</span>
          </div>
        )}
        {status && (
          <div className="mt-3 md:mt-4">
            <Badge variant={getStatusVariant()} dot size="default">
              {status === 'success' ? 'Above Break-even' : status === 'warning' ? 'Near Break-even' : 'Below Break-even'}
            </Badge>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default KPICard;